import { render } from "./BetLimit.vue?vue&type=template&id=68346358"
const script = {}

import exportComponent from "/codebuild/output/src2796879663/src/bitbucket.org/island-c/cayman-fe-operator/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__